import { render, staticRenderFns } from "./WeightInfoModal.vue?vue&type=template&id=b26c97c8&scoped=true&"
import script from "./WeightInfoModal.vue?vue&type=script&lang=js&"
export * from "./WeightInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./WeightInfoModal.vue?vue&type=style&index=0&id=b26c97c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26c97c8",
  null
  
)

export default component.exports